module.exports = __webpack_public_path__ + "static/media/dashboard.e6caa9d5.png";